export type IxdMatchPreviewTabStatus = "ready" | "failed";

interface IxdMatchPreviewTabMessage {
  type: "ixd-match-preview-status";
  status: IxdMatchPreviewTabStatus;
}

export const isIxdMatchPreviewTabMessage = (
  value: unknown,
): value is IxdMatchPreviewTabMessage => {
  if (!value || typeof value !== "object") return false;
  const candidate = value as Partial<IxdMatchPreviewTabMessage>;
  return (
    candidate.type === "ixd-match-preview-status" &&
    (candidate.status === "ready" || candidate.status === "failed")
  );
};

/**
 * 선택 화면이 연 비교 탭에만 상태를 알린다. 직접 진입하거나 새로고침한 탭은
 * opener가 없으므로 기존 오류 화면을 유지한다.
 */
export const notifyIxdMatchPreviewOpener = (
  status: IxdMatchPreviewTabStatus,
): boolean => {
  const opener = window.opener as Window | null;
  if (!opener || opener.closed) return false;
  opener.postMessage(
    { type: "ixd-match-preview-status", status },
    window.location.origin,
  );
  return true;
};
